export var filterUsersList = function (filterString, arrayToBeFiltered) {
    if (arrayToBeFiltered && Array.isArray(arrayToBeFiltered)) {
        var filteredArray = arrayToBeFiltered.filter(function (obj) {
            if (!obj.firstName)
                return false;
            return obj.firstName.toLowerCase().includes(filterString);
        });
        return filteredArray;
    }
    return undefined;
};
export var filterUsersByStatus = function (userList, onload, showLoggedInUser) {
    var _a;
    var finalObject = { activeUsers: undefined, nonActiveUsers: undefined };
    var activeUsersArr = [], nonActiveUsersArr = [];
    var userId = (_a = onload === null || onload === void 0 ? void 0 : onload.user) === null || _a === void 0 ? void 0 : _a.id;
    userList === null || userList === void 0 ? void 0 : userList.forEach(function (user) {
        var _a;
        if (userId === (user === null || user === void 0 ? void 0 : user.id)) {
            if (showLoggedInUser)
                activeUsersArr.push(user);
        }
        else if (((_a = user === null || user === void 0 ? void 0 : user.status) === null || _a === void 0 ? void 0 : _a.id) === 0)
            activeUsersArr.push(user);
        else
            nonActiveUsersArr.push(user);
    });
    finalObject.activeUsers = activeUsersArr;
    finalObject.nonActiveUsers = nonActiveUsersArr;
    return finalObject;
};
export var matchNameWithSearchString = function (searchString, currentUser) {
    var _a;
    if (searchString === void 0) { searchString = ""; }
    var firstName = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.firstName) || "";
    var lastName = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.lastName) || "";
    var nameString = !firstName && !lastName ? currentUser === null || currentUser === void 0 ? void 0 : currentUser.userName : "".concat(firstName, " ").concat(lastName);
    var stringLowerCased = searchString === null || searchString === void 0 ? void 0 : searchString.toLowerCase();
    return (nameString === null || nameString === void 0 ? void 0 : nameString.toLowerCase().includes(stringLowerCased)) || ((_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.userName) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(stringLowerCased));
};
export function getAllNames(roles) {
    if (!roles)
        return [];
    var roleNames = roles === null || roles === void 0 ? void 0 : roles.map(function (role) { var _a; return (_a = role === null || role === void 0 ? void 0 : role.name) === null || _a === void 0 ? void 0 : _a.toLowerCase(); });
    return roleNames;
}
export function getNewName(names, actualName) {
    var nameToReturn = actualName;
    try {
        var regexForEndsWithNumber = / \d{1,3}$/;
        var matchedString = actualName === null || actualName === void 0 ? void 0 : actualName.match(regexForEndsWithNumber);
        if ((names === null || names === void 0 ? void 0 : names.includes(actualName === null || actualName === void 0 ? void 0 : actualName.toLowerCase())) && (matchedString === null || matchedString === void 0 ? void 0 : matchedString[0])) {
            var nameWithoutNumber = nameToReturn.substring(0, matchedString === null || matchedString === void 0 ? void 0 : matchedString.index);
            actualName = nameWithoutNumber;
        }
    }
    catch (err) {
        console.error(err);
    }
    var name = actualName === null || actualName === void 0 ? void 0 : actualName.toLowerCase();
    var numbers = names.map(function (oneName) {
        var regex = new RegExp("^".concat(name, "(\\s*\\d+)*$"), 'gi');
        var regexOutput = regex.exec(oneName);
        if (regexOutput && regexOutput[0] === oneName && regexOutput[1]) {
            try {
                var num = Number.parseInt(regexOutput[1].trim());
                return num;
            }
            catch (e) {
                console.error(e);
                return undefined;
            }
        }
        else
            return undefined;
    }).filter(function (ob) { return ob !== undefined; });
    if (numbers.length === 0 && names.includes(name)) {
        nameToReturn = actualName + ' ' + 1;
    }
    else if (numbers.length > 0 && names.includes(name)) {
        for (var i = 1; i < 500; i++) {
            if (!numbers.includes(i)) {
                nameToReturn = actualName + ' ' + i;
                break;
            }
        }
    }
    return nameToReturn;
}
export function scrollToRole(roleElemId, containerElemId) {
    try {
        var role = document.getElementById(roleElemId);
        var roleTopOffset = role === null || role === void 0 ? void 0 : role.offsetTop;
        var containerElem = document.getElementById(containerElemId);
        if (containerElem && roleTopOffset)
            containerElem.scrollTop = roleTopOffset - 100;
    }
    catch (err) {
        console.error(err);
    }
}
//# sourceMappingURL=roles.js.map